export const getERUforEA = (builder) => ({
    getERUforEA: builder.mutation({
        query: ({ user_id }) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';

            return {
                url: `/eru_drop_down_acc_ea/${user_id}`,
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
})